export enum MART_PRODUCT_REQUEST_ID_LIST {
  POST_MART_PRODUCT = 'POST_MART_PRODUCT',
  PATCH_MART_PRODUCT = 'PATCH_MART_PRODUCT',
  DELETE_MART_PRODUCT = 'DELETE_MART_PRODUCT',
  POST_MART_PRODUCT_INQUIRY = 'POST_MART_PRODUCT_INQUIRY',
  GET_BASKET_LIMIT = 'GET_BASKET_LIMIT',
  POST_CALCULATE_PRODUCT_ORDER_LIMIT_WEIGHT = 'POST_CALCULATE_PRODUCT_ORDER_LIMIT_WEIGHT',
  POST_CALCULATE_PRODUCT_ORDER_LIMIT_SIZE = 'POST_CALCULATE_PRODUCT_ORDER_LIMIT_SIZE',
}

export enum MART_PRODUCT_TRANSLATION_KEY {
  PRODUCT_NAME_TH_DUP = 'productNameTH.isDuplicated',
  PRODUCT_NAME_EN_DUP = 'productNameEN.isDuplicated',
  PRODUCT_NAME_TH_INVALID = 'productNameTH.isInvalid',
  PRODUCT_NAME_EN_INVALID = 'productNameEN.isInvalid',
  PRODUCT_SKU_ID_INVALID = 'productSKUId.isInvalid',
  PRODUCT_SKU_ID_REQUIRED = 'productSKUId.isRequired',
  PRODUCT_DESC_TH_INVALID = 'productDescriptionTH.isInvalid',
  PRODUCT_DESC_EN_INVALID = 'productDescriptionEN.isInvalid',
  PRODUCT_CATEGORY_NOT_FOUND = 'productCategory.notFound',
  PRODUCT_NOT_FOUND = 'product.notFound',
  TAG_NOT_FOUND = 'tag.notFound',
  PRODUCT_PRICE_INVALID = 'productPrice.isInvalid',
  START_DATE_TIME_INVALID = 'promoStartDateTime.isInvalid',
  END_DATE_TIME_INVALID = 'promoEndDateTime.isInvalid',
  EXCEED_MAX_START_DATE_TIME = 'promoStartDateTime.overThan90days',
  EXCEED_MAX_END_DATE_TIME = 'promoEndDateTime.overThan365days',
  SAME_DATE_TIME = 'promoEndDateTime.lessThan30minutes',
}

export enum MART_PRODUCT_INLINE_ERROR {
  PRODUCT_NAME_DUP = 'ชื่อรายการซ้ำ กรุณาตั้งชื่อใหม่',
  PRODUCT_NAME_TH_INVALID = `ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  PRODUCT_NAME_EN_INVALID = `ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  PRODUCT_SKU_ID_INVALID = `ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  PRODUCT_DESC_TH_INVALID = `ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  PRODUCT_DESC_EN_INVALID = `ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  TAG_NOT_FOUND = 'กรุณาเลือกประเภทใหม่อีกครั้ง',
  PRODUCT_PRICE_INVALID = 'กรุณาใส่ราคาลดต่ำกว่าราคาเต็ม',
  PROMO_START_DATETIME_INVALID = 'กรุณาเลือกวันและเวลาเริ่มต้นใหม่',
  PROMO_END_DATETIME_INVALID = 'กรุณาเลือกวันและเวลาสิ้นสุดใหม่',
  PROMO_SAME_DATETIME = 'ระยะเวลาของโปรโมชันต้องมากกว่า 30 นาทีขึ้นไป',
  PROMO_START_DATETIME_EXCEED = 'ตั้งค่าโปรโมชันล่วงหน้าได้ไม่เกิน 3 เดือน',
  PROMO_END_DATETIME_EXCEED = 'ระยะเวลาของโปรโมชันต้องไม่เกิน 365 วัน',
}

export enum MART_PRODUCT_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum PRODUCT_WEIGHT_UNIT {
  GRAM = 1,
  KILOGRAM = 2,
  MILLILITER = 3,
  LITER = 4,
}

export enum PDQC_STATUS {
  PDQC_APPROVE = 'PDQC-APPROVE',
  PDQC_REJECT = 'PDQC-REJECT',
  PDQC_NEW = 'PDQC-NEW',
  PDQC_PENDING_CAN_SELL = 'PDQC-CANSELL',
  PDQC_PENDING_CANNOT_SELL = 'PDQC-CANNOTSELL',
}

export enum MART_PAGINATION {
  DEFAULT_OFFSET = 0,
  DEFAULT_LIMIT = 50,
  DEFAULT_CURRENT = 1,
}

export const MART_PRODUCT_LIST_PAGE_OPTION = ['50', '100'];
export const PRODUCT_PRICE_REGEX = /^([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)\.*([0-9]){0,2}$/;
export const PRODUCT_PRICE_MAXLENGTH = 12;

export enum PROMOTION_STATUS {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
}
